import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import CryptoJS from "crypto-js";
import { ToastController } from "ionic-angular";

/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalProvider {
  VERSION_INSTALADA: string = "1.7.2"; //Versión instalada

  public URLBASE: string = "https://intranet.aloepluslanzarote.com/";
  public URLBASEJSON: string = this.URLBASE + "appaloe/";
  public URLSTATIC: string = this.URLBASE + "/static/";
  public URLMEDIA: string = this.URLBASE + "/static/media/";

  public INTRALOESETTING: any;

  public LOGGED: boolean = false;

  public DATAUSER: any = {};

  public UKT: any = {};

  public CONFIGURA: any = {};

  public REGAPP: any = {
    uuid: "",
    regid: "",
  };

  constructor(
    public http: HttpClient,
    private storage: Storage,
    private toastCtrl: ToastController
  ) {
    console.log("Hello GlobalProvider Provider");
  }

  calcula_ukt(u, c) {
    var usuario = u.toLowerCase();
    var p_encrypted = CryptoJS.SHA1(usuario + CryptoJS.SHA1(c)).toString();
    var eltoken = this.calculaToken(usuario, c).toString();

    var ukt = { u: u, k: p_encrypted, t: eltoken };
    return ukt;
  }

  setConfigura(setting) {
    this.CONFIGURA = setting;
    this.storage.set("CONFIGURA", setting);
  }

  setuuid(puuid) {
    this.REGAPP["uuid"] = puuid;
    this.storage.set("REGAPP", this.REGAPP);
  }

  setregid(pregid) {
    this.REGAPP["regid"] = pregid;
    this.storage.set("REGAPP", this.REGAPP);
  }

  setukt(ukt) {
    this.UKT = ukt;
    this.storage.set("UKT", ukt);
  }

  getukt() {
    this.storage.get("UKT").then((val) => {
      return val;
    });
  }

  setlogged(estado) {
    this.LOGGED = estado;
    this.storage.set("Logged", estado);
  }

  setDataUser(data) {
    this.DATAUSER = data;
    this.storage.set("DataUser", data);
  }

  calculaToken(u, p) {
    //  sha1 ( sha1( u + sha1(p) ) + SECRETO )
    var SECRETO = "Ad.g%dsj8.mgiswXGFoihg?fkw=chj";
    var p_en = CryptoJS.SHA1(p);
    var ke = CryptoJS.SHA1(u.toString() + p_en);
    var eltoken = CryptoJS.SHA1(ke + SECRETO);

    return eltoken;
  }

  //Crear mensaje toast
  crearToast(mensaje, duracion = 2500, position = "middle") {
    const toast = this.toastCtrl.create({
      message: mensaje,
      duration: duracion,
      position: position,
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts